import { CircularProgress } from "@material-ui/core";
import { LangSwitch } from "../_components/LangSwitch";
import TextField from "@material-ui/core/TextField";
import React from "react";
import { connect } from "react-redux";
import { cn as lang_cn } from "../_lang/cn.json";
import { en as lang_en } from "../_lang/en.json";
import { ru as lang_ru } from "../_lang/ru.json";

import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import CustomizedButton from "../_components/buttons/CustomizedButton";

// Прямые импорты, а не бочка "../_components": та реэкспортирует PrivateRoute,
// который тянет DefaultLayout с MUI v4 Drawer, AppMenu и HeadMenu — в сборке
// режима «визитка» это лишние ~160 КБ gzip.
import { Snack } from "../_components/Snack";
import { TextFieldCell } from "../_components/TextFieldCell";
import { history, initLanguage, store } from "../_helpers";
import { startOAuth } from "../CardApp/nativeBridge";

import CookiePopup from "../MainPage/CookiePopup";
import { userActions } from "../_actions";
import { defaultLang, serverUrl, vkontakteOAuthDisabled, leaderIdOAuthDisabled, alipayOAuthDisabled, yandexOAuthDisabled, sberOAuthDisabled, cardMode } from "../_constants";
import "../css/style.css";

import LeaderLogo from "../img/leader_id.png";
import vkLogo from "../img/vk.png";
import yandexLogo from "../img/yandex.png";
import sberLogo from "../img/sber.png";


import { AlipayOAuthButton } from "./AlipayOAuthButton";

const loginIsEmail = process.env.REACT_APP_LOGIN_IS_EMAIL == "true";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // reset login status

    this.state = {
      username: "",
      pwd: "",
      submitted: false,
      alertShow: false,
      err_type: "",
      snackText: "",
      showPwd: false,
    };

    store.subscribe(this.storeChange);
  }

  storeChange = (e) => {
    const { error, isLoading } = store.getState().authentication;
    if (!error || isLoading) return;

    // Бэк присылает i18n-ключ в errors.email (формат Laravel 422), а не готовый текст:
    // сейчас так помечен единственный случай — аккаунт заведён через провайдера и пароля
    // не имеет. Общее «неправильные email и пароль» там уводит в тупик, пароля-то нет.
    const response = error?.response;
    const serverKey = response?.data?.errors?.email?.[0];
    const knownKey = serverKey === "login_registered_via_provider";

    // Про пароль говорим только там, где бэк действительно отверг учётные данные,
    // то есть на 422. Раньше эту фразу получала любая неудача входа, включая 500,
    // и диагноз уходил в сторону: в приложении «визитка» POST api/token с create_type
    // падал на стороне сервера, а человек читал «неправильные email и пароль» и искал
    // ошибку в пароле, которого у него ещё не было. Детали — в консоль: показывать
    // сообщение бэкенда нельзя, там приходит внутренняя ошибка целиком.
    const credentialsRejected = response?.status === 422;
    if (response && !credentialsRejected) {
      console.error("[login] HTTP", response.status, response.data?.message);
    }

    let snackText;
    if (!response) {
      // Ответа нет вовсе — связь, а не учётные данные.
      snackText = this.getI18N("network_error");
    } else if (knownKey) {
      snackText = this.getI18N(serverKey);
    } else if (credentialsRejected) {
      snackText = loginIsEmail
        ? this.getI18N("incorrect_email_pwd")
        : this.getI18N("incorrect_login_pwd");
    } else {
      snackText = this.getI18N("unknown_error_contact_support");
    }

    this.setState({
      snackText,
      alertShow: true,
      err_type: "error",
    });
  };

  componentDidMount() {
    const { dispatch } = this.props;

    //alert(process.env.REACT_APP_LOGIN_IS_EMAIL);

    const username = localStorage.getItem("navic_user");
    const pwd = localStorage.getItem("navic_pwd");

    localStorage.setItem("nc_usertype", "");

    let lang = localStorage.getItem("navic_lang") ?? defaultLang;
    this.setState({ lang });

    if (username && pwd) {
      this.setState({ username, pwd });
      dispatch(userActions.login({ username, password: pwd }));
    }
  }

  // В мобильном приложении вход через провайдера открывается снаружи: обёртка получает
  // сообщение и отдаёт ссылку системе, дальше решает Android/iOS — приложение провайдера
  // или браузер, где сессия уже есть. В вебе ссылка отрабатывает как раньше; тип
  // пользователя для входа (в отличие от регистрации) не передаётся.
  clickOAuth = (provider) => (e) => {
    if (startOAuth(provider)) e.preventDefault();
  };

  getI18N = (textKey) => {
    const { lang } = this.state;

    if (!lang) return;

    if (lang == "ru") {
      if (Object.keys(lang_ru.translation).indexOf(textKey) >= 0)
        return lang_ru.translation[textKey];
    }

    if (lang == "en")
      if (Object.keys(lang_en.translation).indexOf(textKey) >= 0)
        return lang_en.translation[textKey];

    if (lang == "cn")
      if (Object.keys(lang_cn.translation).indexOf(textKey) >= 0)
        return lang_cn.translation[textKey];

    return textKey;
  };

  onCloseSnack = () => {
    this.setState({ alertShow: false });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  openReg = () => {
    // alert(window.location.href);
    history.push("/registration");
  };

  handleSubmit = (e) => {
    const self = this;

    e.preventDefault();

    this.setState({ submitted: true });
    const { username, pwd } = this.state;
    const { dispatch } = this.props;

    if (username.length == 0 || pwd.length == 0) {
      this.setState({
        snackText: this.getI18N("enter_email_pwd"),
        alertShow: true,
        err_type: "warning",
      });
      return;
    }

    // В приложении та же кнопка заводит аккаунт, если email незнакомый, поэтому длину
    // пароля проверяем здесь: иначе человек узнает про минимум в 6 символов только
    // по 422 с бэка, уже нажав «Продолжить».
    if (cardMode && pwd.length < 6) {
      this.setState({
        snackText: this.getI18N("the_password_must_be_6_characters"),
        alertShow: true,
        err_type: "warning",
      });
      return;
    }

    localStorage.setItem("user", "{}");

    dispatch(
      userActions.login({
        username,
        password: pwd,
        // Вход и регистрация в приложении — одно действие: неизвестный email заводит
        // посетителя (бэк, POST api/token с create_type). Веб шлёт запрос без него.
        createType: cardMode ? "student" : undefined,
      })
    );
  };

  changeLang = (lang) => {
    localStorage.setItem("navic_lang", lang);
    this.setState({ lang });
  };

  render() {
    initLanguage();

    const { error, isLoading } = this.props;

    const {
      username,
      submitted,
      pwd,
      alertShow,
      err_type,
      snackText,
      showPassword,
      lang,
    } = this.state;

    let errorMsg = this.getI18N("incorrect_token");
    if (error) {
      if (error === "Forbidden") errorMsg = this.getI18N("incorrect_token");
    }

    const anyOAuthEnabled =
      !vkontakteOAuthDisabled ||
      !leaderIdOAuthDisabled ||
      !alipayOAuthDisabled ||
      !yandexOAuthDisabled ||
      !sberOAuthDisabled;

    // Один и тот же блок провайдеров рисуется в разных местах экрана: в приложении
    // это основной способ входа и стоит над формой, в вебе — как раньше, под ней.
    const oauthBlock = process.env.REACT_APP_DISABLE_REG != "true" && (
      <>
        {/* Без подписи иконки не читаются как кнопки входа — в вебе рядом с ними
            есть форма и кнопки, в приложении они идут первыми. */}
        {cardMode && anyOAuthEnabled && (
          <div className="card-login__oauth-hint">
            {this.getI18N("login_oauth_hint")}
          </div>
        )}
        <div
          style={{
            marginTop: cardMode ? 12 : 20,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {!vkontakteOAuthDisabled && (<a href={serverUrl + "auth/vkontakte"} onClick={this.clickOAuth("vkontakte")}>
            <img src={vkLogo} />
          </a>)}
          {!leaderIdOAuthDisabled && (<a href={serverUrl + "auth/leader-id"} style={{ marginLeft: 40 }} onClick={this.clickOAuth("leader-id")}>
            <img src={LeaderLogo} />
          </a>)}
          {!yandexOAuthDisabled && (<a href={serverUrl + "auth/yandex"} style={{ marginLeft: 40 }} onClick={this.clickOAuth("yandex")}>
            <img src={yandexLogo} />
          </a>)}
          {!sberOAuthDisabled && (<a href={serverUrl + "auth/sber-id"} style={{ marginLeft: 40 }} onClick={this.clickOAuth("sber-id")}>
            <img src={sberLogo} />
          </a>)}
          <AlipayOAuthButton />
        </div>
      </>
    );

    return (
      <div style={{ width: "100%", height: "100%", verticalAlign: "center" }}>
        {/* Переключателя языка в мобильном приложении нет: язык берётся из профиля,
            иначе из системной локали телефона (см. CardApp/CLAUDE.md). */}
        {process.env.REACT_APP_DISABLE_REG != "true" && !cardMode && (
          <div
            style={{ position: "absolute", top: 20, left: 20, fontSize: 20 }}
          >
            <LangSwitch
              lang={lang}
              onChange={this.changeLang}
              labelStyle={{ fontSize: 16 }}
            />
          </div>
        )}
        {/* В приложении провайдеры идут первыми — это основной путь входа с
            автозаполнением анкеты, а вход по email оставлен запасным. В вебе
            порядок прежний: форма, под ней провайдеры. */}
        {cardMode && (
          <div className="card-login__top">
            {oauthBlock}
            <div className="card-login__divider">
              <span>{this.getI18N("login_or")}</span>
            </div>
          </div>
        )}

        {/* width:400 фиксированной шириной не влезает в экран телефона (390px):
            поля упираются в край, кнопка регистрации обрезается. В кабинете это
            не видно — там десктоп. */}
        <div
          className={cardMode ? "card-login__form" : ""}
          style={{
            width: "100%",
            maxWidth: 400,
            margin: "0 auto",
            // Боковые поля нужны не только «визитке»: в кабинете внутри WebView
            // контейнер в 400px шире экрана телефона, и кнопка регистрации
            // обрезалась правым краем.
            padding: cardMode ? "0 20px" : "0 16px",
            paddingTop: cardMode ? 0 : "30vh",
          }}
        >
          <form name="form" onSubmit={this.handleSubmit}>
            <div className={submitted && !username ? " has-error" : ""}>
              <TextFieldCell
                id="login"
                label={
                  loginIsEmail
                    ? this.getI18N("user_email")
                    : this.getI18N("user_login")
                }
                name="username"
                type="text"
                value={username}
                onChange={this.handleChange}
                // Автофокус в приложении сразу поднимает клавиатуру и прячет
                // кнопки провайдеров — то есть основной путь входа.
                autoFocus={!cardMode}
                InputProps={cardMode ? { fontSize: 16, fontWeight: 400 } : undefined}
              />
            </div>
            <div className={submitted && !username ? " has-error" : ""}>
              <TextField
                style={{ display: "flex", marginBottom: 20 }}
                id="pwd"
                label={this.getI18N("password")}
                name="pwd"
                type={showPassword ? "text" : "password"}
                value={pwd}
                onChange={this.handleChange}
                InputProps={{
                  style: cardMode
                    ? { fontSize: 16, color: "#0b1218" }
                    : { fontSize: 24, fontWeight: "bold", color: "#0b1218" },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          this.setState({ showPassword: !showPassword })
                        }
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* Отдельного экрана регистрации в приложении нет: незнакомый email заводит
                посетителя тем же запросом (create_type), поэтому кнопка одна. */}
            {cardMode ? (
              <>
                <button type="submit" className="btn card-login__submit">
                  {this.getI18N("login_continue")}
                </button>
                <p className="card-login__note">
                  {this.getI18N("login_auto_register_hint")}
                </p>
              </>
            ) : (
              <div
                className="form-group"
                style={{
                  marginTop: 5,
                  justifyContent: "space-between",
                  flex: 1,
                  display: "flex",
                }}
              >
                <CustomizedButton
                  style={{ marginBottom: 5 }}
                  id="category-button-add"
                  type="submit"
                  title={this.getI18N("login_enter")}
                  prim
                />
                {process.env.REACT_APP_DISABLE_REG != "true" && (
                  <CustomizedButton
                    style={{ marginBottom: 5 }}
                    onClick={this.openReg}
                    id="category-button-add"
                    title={this.getI18N("registration")}
                    prim
                  />
                )}
              </div>
            )}
          </form>
          {/* В режиме «визитка» страницы сброса пароля нет в сборке — ссылка вела бы
              на редирект в никуда. Боевой вход там через OAuth. */}
          {!cardMode && (
            <div style={{ marginTop: 10, textDecoration: "underline" }}>
              <a href="/password-forgot" className="forgot-password-link">
                {this.getI18N("forgot_password")}
              </a>
            </div>
          )}
        </div>

        {!cardMode && oauthBlock}

        {isLoading && (
          <div className="shadow">
            <div className="shadow_circle">
              <CircularProgress />
            </div>
          </div>
        )}
        {/* Внутри мобильного приложения баннер про cookie неуместен: это не сайт,
            согласие берётся при регистрации. Плюс он съедает треть экрана. */}
        {!cardMode && <CookiePopup />}
        <Snack
          open={alertShow}
          variant={err_type}
          text={snackText}
          onClose={this.onCloseSnack}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn, error, isLoading } = state.authentication;
  return {
    loggingIn,
    isLoading,
    error,
  };
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage };
